import React from 'react';

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-14 h-14 text-base',
  xl: 'w-20 h-20 text-xl',
};

export default function Avatar({ src, name, size = 'md', className = '' }) {
  const initials = name
    ? name.split(' ').filter(Boolean).map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  if (src) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        className={['rounded-full object-cover ring-2 ring-sand-200', sizes[size], className].join(' ')}
      />
    );
  }

  return (
    <div
      className={['rounded-full bg-terra-400/20 text-terra-600 font-semibold flex items-center justify-center shrink-0', sizes[size], className].join(' ')}
    >
      {initials}
    </div>
  );
}
